import React, { useContext } from 'react';
import { Grid } from 'react-bootstrap';

import Pagination from '../../../../../components/Pagination';
import Spinner from '../../../../../components/Loaders/Spinner';
import { SubscriptionsMainContext } from '../../index';
import { Body, Table } from '../../../../../components/Table/Grid';
import SubscriptionsTableBody from './Body';
import SubscriptionsTableHeader from './Header';

const SubscriptionsTable = () => {
  const [store, dispatch] = useContext(SubscriptionsMainContext);
  const { subscriptions, pagination, isLoadingTable, isLoadingPagination, checked, filters, configuration } = store;
  const { access } = configuration;
  return (
    <>
      <Grid fluid>
        <Table>
          <SubscriptionsTableHeader />
          <Body isLoading={isLoadingTable}>
            <SubscriptionsTableBody
              subscriptions={subscriptions}
              checked={checked}
              filters={filters}
              isLoadingTable={isLoadingTable}
              dispatch={dispatch}
              access={access}
            />
          </Body>
        </Table>
      </Grid>
      <Grid fluid>
        {isLoadingPagination ? (
          <div className="pagination">
            <Spinner />
          </div>
        ) : (
          <Pagination
            withPageSizer
            pages={pagination?.pages}
            currentPage={pagination?.current_page}
            itemsCount={pagination?.total_count}
            pageSize={pagination?.page_size}
            pagesLimit={pagination?.pages < 10 ? pagination?.pages : 10}
          />
        )}
      </Grid>
    </>
  );
};

SubscriptionsTable.propTypes = {};

export default SubscriptionsTable;
